// 校验表格是否正确
import { getArea } from '@/apis/shopcart'
import { t } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'
import { getCountryListApi, getAreaListApi } from '@/apis/user'
import { getTotalCountryList } from '@/util/useCountry'
import { useSite, isKO, isJA } from '@/store'
const ORDER_1 = t('order_客户订单号')
const ORDER_2 = t('order_直行便SKU')
const ORDER_3 = t('order_数量')
const ORDER_4 = t('order_收件人姓名')
const ORDER_5 = t('order_联系电话')
const ORDER_11 = t('order_个人通关码')
const ORDER_10 = t('order_国家')
const ORDER_6 = t('order_都道府县')
const ORDER_7 = t('order_市')
const ORDER_8 = t('order_详细地址')
const ORDER_9 = t('order_邮编')
const addressObjMap: any = {}
const areaObjMap:any = {}

getArea({ type: 0 }).then((res: any) => {
  res.data.forEach((item: any) => {
    addressObjMap[item.label] = {}
    item.children.forEach((temp: any) => {
      addressObjMap[item.label][temp.label] = 1
    })
  })
  console.log('address', addressObjMap)
})
// 获取地区信息缓存
const getAreaList = async (intAreaId:string) => {
  if (areaObjMap[intAreaId]) {
    return areaObjMap[intAreaId]
  }
  const area = await getAreaListApi({ intAreaId }).then((res) => {
    areaObjMap[intAreaId] = res.data
    return res.data
  })
  return area
}
export const checkOrderExcel = async (excelList: any) => {
  // if (excelList.length === 0) {
  //   ElMessage.warning(t('请勿上传空文件'))
  //   return false
  // }
  // if (excelList.length > 1000) {
  //   ElMessage.warning(t('表格数据最多为1000行，请分多个表格导入'))
  //   return false
  // }
  // 可配置的国家
  // 韩国站只能发韩国！
  const countryResult = !isKO() ? await getCountryListApi({}).then((res) => res.data) : [{ countryCode: 'KR' }]
  const totalCountry: any = await getTotalCountryList()
  // 整理后可配置国家列表
  const list:any = []
  countryResult.forEach((i: any) => {
    const countryItem = totalCountry.find((k: any) => k.code === i.countryCode)
    countryItem && list.push(countryItem)
  })
  if (list.length === 0) {
    ElMessage.warning(t('当前用户未配置可发送国家'))
    return
  }
  const l = await Promise.all(list.map((i:any) => getAreaList(i.intAreaId)))
  const addressMap:any = {}
  l.forEach((item:any) => {
    // 国家
    const countryName = isJA() ? 'nameJa' : isKO() ? 'nameKr' : 'nameEn'
    addressMap[item[countryName]] = {}
    if (item.children?.length > 0) {
      // 地区
      let name = 'nameEn'
      if (isJA()) {
        name = item.code === 'JP' ? 'nameJa' : 'nameEn'
      }
      if (isKO()) {
        name = item.code === 'KR' ? 'nameKr' : 'nameEn'
      }
      item.children.forEach((cItem:any) => {
        addressMap[item[countryName]][cItem[name]] = {}
        if (cItem.children?.length > 0) {
          cItem.children.forEach((ccItem:any) => {
            addressMap[item[countryName]][cItem[name]][ccItem[name]] = {}
          })
        }
      })
    }
  })
  console.log('整理后可配置国家列表', addressMap)
  //  存在多行商品相同订单号，先讲订单号相同的归类
  const orderInfo: any = {
    // ORDER_1: {
    //   sku : [index]
    // },
  }
  const addressInfo: any = {
    // ORDER_1: {
    //   address : index
    // },
  }
  const customsInfo: any = {
    // ORDER_1: {
    //   customs : index
    // },
  }
  excelList.forEach((item: any, index: any) => {
    item.rowNumber = index + 2
    item.customerOrderNo = item[ORDER_1] ?? ''
    item.productSku = item[ORDER_2] ?? ''
    if (!item[ORDER_1]) {
      item.error = t('客户订单号不能为空')
      return
    }
    if (!/^[\S ]{1,32}$/.test(item[ORDER_1])) {
      item.error = t('客户订单号最长为32个字符')
      return
    }
    if (!item[ORDER_2]) {
      item.error = t('商品SKU不能为空')
      return
    }
    if (!/^[\S ]{6,100}$/.test(item[ORDER_2])) {
      item.error = t('请输入6~100个字符的商品SKU')
      return
    }
    // 校验是否相同订单号sku重复
    if (!orderInfo[item[ORDER_1]]) {
      orderInfo[item[ORDER_1]] = {}
    }
    if (Object.keys(orderInfo[item[ORDER_1]]).indexOf(item[ORDER_2]) === -1) {
      // 不存在相同sku
      orderInfo[item[ORDER_1]][item[ORDER_2]] = [index]
    } else {
      orderInfo[item[ORDER_1]][item[ORDER_2]] = [...orderInfo[item[ORDER_1]][item[ORDER_2]], index]
      orderInfo[item[ORDER_1]][item[ORDER_2]].forEach((skuIndex: any) => {
        excelList[skuIndex].error = t('第X行，同一个客户订单号SKU有且仅能有一行').replace('X', orderInfo[item[ORDER_1]][item[ORDER_2]].map((i: number) => i + 2).join(','))
      })
      item.error = t('第X行，同一个客户订单号SKU有且仅能有一行').replace('X', orderInfo[item[ORDER_1]][item[ORDER_2]].map((i: number) => i + 2).join(','))
    }
    // 数量大于等于1的整数
    if (!item[ORDER_3]) {
      item.error = t('数量不能为空')
      return
    }
    if (!/^[1-9]+[0-9]*$/.test(item[ORDER_3])) {
      item.error = t('请输入大于等于1的整数')
      return
    }
    // 收件人姓名1~50字符
    if (!item[ORDER_4]) {
      item.error = t('收件人姓名不能为空2')
      return
    }
    if (!/^[\S ]{1,50}$/.test(item[ORDER_4])) {
      item.error = t('请输入1-50个字符的收件人姓名')
      return
    }
    // 联系方式 大于等于6个字符
    if (!item[ORDER_5]) {
      item.error = t('联系方式不能为空')
      return
    }
    if (!/^[0-9]{8,11}$/.test(item[ORDER_5]) && isJA()) {
      item.error = t('请输入8-11字符的联系方式')
      return
    }
    // 判断是否有国家
    if (!item[ORDER_10]) {
      item.error = t('国家不能为空')
      return
    }
    if (!addressMap[item[ORDER_10]]) {
      item.error = t('国家填写有误')
      return
    }
    // 都道府县 1~50个字符
    if (!item[ORDER_6]) {
      item.error = t('都道府县不能为空2')
      return
    }
    if (!/^[\S ]{1,50}$/.test(item[ORDER_6])) {
      item.error = t('请输入1-50字符的都道府县')
      return
    }
    if (!addressMap[item[ORDER_10]][item[ORDER_6]]) {
      item.error = t('没有该都道府县')
      return
    }
    // 市 1~50个字符
    // if (!item[ORDER_7]) {
    //   item.error = t('市不能为空')
    //   return
    // }
    if (item[ORDER_7] && !/^[\S ]{1,50}$/.test(item[ORDER_7])) {
      item.error = t('请输入1-50字符的市')
      return
    }

    if (item[ORDER_7] && !addressMap[item[ORDER_10]][item[ORDER_6]][item[ORDER_7]]) {
      item.error = t('都道府县与市不匹配')
      return
    }
    // 详细地址 1~200个字符
    if (!item[ORDER_8]) {
      item.error = t('详细地址不能为空2')
      return
    }
    if (!/^[\S ]{1,200}$/.test(item[ORDER_8])) {
      item.error = t('请输入1-200字符的详细地址')
      return
    }

    // 邮编 .7个数字，可包含1个【-】
    if (!item[ORDER_9]) {
      item.error = t('邮编不能为空2')
      return
    }
    if (!/(^\d{3}-?\d{4}$)|(^\d{7}$)/.test(item[ORDER_9]) && isJA()) {
      item.error = t('请输入7位数字的邮编')
      return
    }
    const address = item[ORDER_4] + item[ORDER_5] + item[ORDER_6] + item[ORDER_7] + item[ORDER_8] + item[ORDER_9]
    if (addressInfo[item[ORDER_1]] && !addressInfo[item[ORDER_1]][address]) {
      item.error = t('相同订单下，收件人信息与第X行不一致').replace('X', addressInfo[item[ORDER_1]].index + 2)
    }
    if (!addressInfo[item[ORDER_1]]) {
      addressInfo[item[ORDER_1]] = {}
      addressInfo[item[ORDER_1]][address] = 1
      addressInfo[item[ORDER_1]].index = index
    }
    if (isKO()) {
      // 韩国站校验通关码
      if (!item[ORDER_11]) {
        item.error = t('个人通关码不能为空')
        return
      }
      if (customsInfo[item[ORDER_1]] && !customsInfo[item[ORDER_1]][item[ORDER_11]]) {
        item.error = t('相同订单下，通关码信息与第X行不一致').replace('X', addressInfo[item[ORDER_1]].index + 2)
      }
      if (!customsInfo[item[ORDER_1]]) {
        customsInfo[item[ORDER_1]] = {}
        customsInfo[item[ORDER_1]][item[ORDER_11]] = 1
        customsInfo[item[ORDER_1]].index = index
      }
    }
  })
  return excelList
}

const GOOD_1 = t('good_直行便SKU')
const GOOD_2 = t('good_数量')
const GOOD_3 = t('good_客户SKU')

// 导入商品
export const checkGoodsExcel = (excelList: any): any => {
  if (!excelList || excelList.length === 0) {
    ElMessage.warning(t('请勿上传空文件'))
    return false
  }
  if (excelList.length > 200) {
    ElMessage.warning(t('表格数据最多为200行，请分多个表格导入'))
    return false
  }
  const goodsInfo: any = {}
  excelList.forEach((item: any, index: number) => {
    item.rowNumber = index + 2
    item.customerProductSku = item[GOOD_3] ?? ''
    item.productSku = item[GOOD_1] ?? ''
    // 客户商品SKU非必填
    if (!item[GOOD_1] || !item[GOOD_2]) {
      item.error = t('数据不完整')
      return
    }
    // !/^[1-9]+[0-9]*$/.test(item[GOOD_2])
    if (!/^[1-9]+[0-9]*$/.test(item[GOOD_2])) {
      item.error = t('数量需为大于0的整数')
      return
    }
    if (goodsInfo[item[GOOD_1]]) {
      goodsInfo[item[GOOD_1]] = [
        ...goodsInfo[item[GOOD_1]],
        index
      ]
      goodsInfo[item[GOOD_1]].forEach((goodsIndex: number) => {
        excelList[goodsIndex].error = t('第X行SKU重复').replace('X', goodsInfo[item[GOOD_1]].map((i: any) => i + 2).join(','))
      })
    } else {
      goodsInfo[item[GOOD_1]] = [index]
    }
  })
  return excelList
}
